export type RoleKey = "admin" | "company_admin" | "operator" | "viewer"

export type NavigationItem = {
  label: string
  href: string
  icon:
    | "home"
    | "cube"
    | "squares"
    | "archive"
    | "shoppingCart"
    | "currencyDollar"
    | "wrench"
    | "users"
    | "buildingStorefront"
    | "scale"
    | "receiptPercent"
    | "calculator"
    | "envelope"
    | "buildingOffice"
    | "plusCircle"
    | "swatch"
  allowedRoles?: RoleKey[]
}

export type NavigationSection = {
  title: string
  items: NavigationItem[]
}

export const navigationSections: NavigationSection[] = [
  {
    title: "Operacional",
    items: [
      { label: "Dashboard", href: "/dashboard", icon: "home" },
      { label: "Produtos", href: "/products", icon: "cube" },
      { label: "Composicao do Produto", href: "/bill_of_materials", icon: "squares" },
      { label: "Estoque", href: "/stock_movements", icon: "archive" },
      { label: "Compras", href: "/purchase_orders", icon: "shoppingCart" },
      { label: "Vendas", href: "/sales_orders", icon: "currencyDollar" },
      { label: "Producao", href: "/production_orders", icon: "wrench" },
    ],
  },
  {
    title: "Backoffice Empresa",
    items: [
      { label: "Usuarios", href: "/users", icon: "users", allowedRoles: ["admin", "company_admin"] },
      { label: "Clientes", href: "/customers", icon: "users", allowedRoles: ["admin", "company_admin", "operator"] },
      { label: "Fornecedores", href: "/suppliers", icon: "buildingStorefront", allowedRoles: ["admin", "company_admin", "operator"] },
      { label: "Unidades", href: "/measurement_units", icon: "scale", allowedRoles: ["admin", "company_admin"] },
      { label: "Fiscal", href: "/tax_profiles", icon: "receiptPercent", allowedRoles: ["admin", "company_admin"] },
      { label: "Custos indiretos", href: "/cost_allocations", icon: "calculator", allowedRoles: ["admin", "company_admin"] },
    ],
  },
  {
    title: "Admin",
    items: [
      { label: "Empresas", href: "/companies", icon: "buildingOffice", allowedRoles: ["admin"] },
    ],
  },
]
